module.exports = __webpack_public_path__ + "media/images/svg/staple-cbbf1c0658141f44fc04e4ed85fa5207.svg";